import type { Entity } from '@api/api/entity-schema';
import { useRegions } from '@terminal/react-query-hooks/geographies/useRegions';
import type { FollowingInsightFeedFilterTabs } from '@terminal/views/insight-feed/components/insight-feed-type-tab-line/InsightFeedTypeTabLine';
import { getOverviewFeedScope, isCountryFeedEntity } from './utils';

export const useOverviewFeedScope = (
  entity: Entity | undefined,
  selectedTab: FollowingInsightFeedFilterTabs
) => {
  const initialScope = getOverviewFeedScope(entity, selectedTab);
  const needsCountryLookup =
    isCountryFeedEntity(entity) &&
    initialScope.activeTab !== 'scenarios' &&
    !initialScope.geography &&
    !!entity?.country?.long;
  const regions = useRegions(needsCountryLookup);
  const countries =
    regions.data?.regions.flatMap(region => region.countries) ?? [];
  return {
    ...getOverviewFeedScope(entity, selectedTab, countries),
    isLoading: needsCountryLookup && regions.isPending,
    isError: needsCountryLookup && regions.isError,
    refetch: regions.refetch,
  };
};
